import { Plus } from "@phosphor-icons/react";
import React from "react";
import { Handle, Position } from "reactflow";
import { useHandleConnection } from "./useHandleConnection";
import { HandleId, OutputHandleProps } from "./types.d";

const OUTPUT_VALID_SOURCES: HandleId[] = [HandleId.Input];

const OutputHandle = ({
  isActive,
  colorActive,
  handleId = HandleId.OutputFlow,
  style,
}: OutputHandleProps) => {
  const {
    isDropTarget,
    backgroundColor,
    baseStyle,
    handleMouseEnter,
    handleMouseLeave,
  } = useHandleConnection({
    handleId,
    validSourceHandles: OUTPUT_VALID_SOURCES,
    isActive,
    colorActive,
    side: "right",
  });

  return (
    <Handle
      type="source"
      position={Position.Right}
      id={handleId}
      style={{ ...baseStyle, backgroundColor, ...style }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Plus
        pointerEvents="none"
        color={isDropTarget || isActive ? "#fff" : "#667085"}
        size={14}
        weight="bold"
      />
    </Handle>
  );
};

export default OutputHandle;
